import GenericBoostModal from "./generic-boost-modal";
import {
    format_currency,
    resetCouponFields,
    resetToBasePrice,
    disableCouponField,
    enableCouponField,
    ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS,
    ORDER_SUMMARY_DISCOUNT_LABEL_CLASS,
    ORDER_SUMMARY_DISCOUNT_PRICE_CLASS,
    ORDER_SUMMARY_DISCOUNT_DISCOUNT_JS,
    BASE_PRICE_ATTR,
    APPLIED_COUPON_FIELD_INPUT,
    CART_SUMMARY_COUPON_FIELD_CLASS,
} from "./cart_summary_helpers";
import { applyPromotion, clearCouponFromCart } from "./submitCoupon";

const SUBSCRIBE_SAVE_RADIO_NAME = "subscribe_and_save";
const SUBSCRIBE_SAVE_RADIO_SELECTOR = `input[name=${SUBSCRIBE_SAVE_RADIO_NAME}]`;
const SUBSCRIBE_SAVE_RADIO_CHECKED_SELECTOR =
    SUBSCRIBE_SAVE_RADIO_SELECTOR + ":checked";

const SUBSCRIBE_SAVE_SUBS_CHECKBOX_NAME = "subscribe_and_save_subs[]";
export const SUBSCRIBE_SAVE_SUBS_CHECKBOX_SELECTOR = `input[name='${SUBSCRIBE_SAVE_SUBS_CHECKBOX_NAME}']`;
const SUBSCRIBE_SAVE_SUBS_CHECKBOX_CHECKED_SELECTOR =
    SUBSCRIBE_SAVE_SUBS_CHECKBOX_SELECTOR + ":checked";

const SS_OPTION_NOT_SUBSCRIBED = ".ss-option-not-subscribed--js";
const SS_OPTION_SUBSCRIBED = ".ss-option-subscribed--js";
const SS_OPTION_SUBSCRIBED_SELECTED_CLASS =
    "subscribe-save-upsell__option-container-selected";
const SS_OPTIONS_CONTAINER = ".subscribe-save-upsell__subscription_options--js";

const ss_discount_map = { 4: 15, 3: 12, 2: 10, 1: 8, 0: 0 };
const ss_discount_percent_to_tier = { 15: 1, 12: 2, 10: 3, 8: 4 };
const IS_ELIGIBLE_FOR_SS_DISCOUNT_ON_THIS_AD =
    "is_eligible_for_subscribe_save_discount_on_this_ad";
const IS_ELIGIBLE_FOR_SS_DISCOUNT_ON_THIS_AD_SELECTOR = `input[name=${IS_ELIGIBLE_FOR_SS_DISCOUNT_ON_THIS_AD}]`;
const SPECIAL_SS_AND_WELCOME_COUPON_CODE = "WELCOME&SAVE";
const WELCOME_2_BOOST_COUPON_CODE = "WELCOME2BOOST";
const SPECIAL_WELCOME_COUPONS = [
    SPECIAL_SS_AND_WELCOME_COUPON_CODE,
    WELCOME_2_BOOST_COUPON_CODE,
];

let gCouponCodeBeforeSubAndSave = "";

function isManualAdEligibleForSSDiscount() {
    let thisManualAdIsEligibleForSSDiscountInput = jQuery(
        IS_ELIGIBLE_FOR_SS_DISCOUNT_ON_THIS_AD_SELECTOR
    );
    return thisManualAdIsEligibleForSSDiscountInput.val() == 1;
}

/**
 * @returns {boolean}
 */
export function userHasSubscribeAndSaveSelected() {
    return (
        $(SUBSCRIBE_SAVE_RADIO_CHECKED_SELECTOR).length > 0 &&
        !($(SUBSCRIBE_SAVE_RADIO_CHECKED_SELECTOR).val() == 0)
    );
}

export const getPercentDiscount = () => {
    let totalCampaignTypes = 0;
    let subscribedCampaignCount = 0;

    jQuery.each(jQuery(SUBSCRIBE_SAVE_SUBS_CHECKBOX_SELECTOR), function () {
        totalCampaignTypes++;
    });

    jQuery.each(
        jQuery(SUBSCRIBE_SAVE_SUBS_CHECKBOX_CHECKED_SELECTOR),
        function () {
            subscribedCampaignCount++;
        }
    );

    if (subscribedCampaignCount === 0) {
        return 0;
    }

    const discountIndex = 4 - (totalCampaignTypes - subscribedCampaignCount);
    return ss_discount_map[discountIndex];
};

const getSubscribeSaveTier = (percent) => {
    return ss_discount_percent_to_tier[percent];
};

const getSubscribeSaveCoupon = (percent) => {
    return "SubscribeSaveTier" + getSubscribeSaveTier(percent);
};

export const isSubscribeAndSaveCouponCode = (coupon) => {
    const ss_discounts = [15, 12, 10, 8];
    const found = ss_discounts.find(
        (percent) => getSubscribeSaveCoupon(percent) === coupon
    );
    return !!found;
};

function handleSubscribeSaveFinalTotalPrice(ignoreReset = false) {
    const isSubcribeAndSaveChecked = userHasSubscribeAndSaveSelected();
    let subscribe_and_save_discount = !isSubcribeAndSaveChecked
        ? 0
        : getPercentDiscount();

    const baseCost = jQuery(ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS).data(
        BASE_PRICE_ATTR
    );

    jQuery(".sub-and-save-disclaimer").toggle(isSubcribeAndSaveChecked);

    let thisManualAdIsEligibleForSSDiscount = isManualAdEligibleForSSDiscount();

    if (
        isSubcribeAndSaveChecked &&
        thisManualAdIsEligibleForSSDiscount &&
        subscribe_and_save_discount > 0
    ) {
        gCouponCodeBeforeSubAndSave = gCouponCodeBeforeSubAndSave
            ? gCouponCodeBeforeSubAndSave
            : jQuery(CART_SUMMARY_COUPON_FIELD_CLASS).val();
        const currentlyAppliedCoupon = gCouponCodeBeforeSubAndSave
            ? gCouponCodeBeforeSubAndSave
            : jQuery(APPLIED_COUPON_FIELD_INPUT).val();

        disableCouponField();

        const ssCoupon = getSubscribeSaveCoupon(subscribe_and_save_discount);

        // https://mobilerealtyapps.atlassian.net/browse/BOOST-6503
        let couponToApply = ssCoupon;
        if (SPECIAL_WELCOME_COUPONS.includes(currentlyAppliedCoupon)) {
            couponToApply = SPECIAL_SS_AND_WELCOME_COUPON_CODE;
        }

        jQuery(APPLIED_COUPON_FIELD_INPUT).val(couponToApply);
        applyPromotion(couponToApply, (data) => {
            jQuery(ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS).text(data.cost);
            jQuery(ORDER_SUMMARY_DISCOUNT_DISCOUNT_JS).show();
            jQuery(ORDER_SUMMARY_DISCOUNT_LABEL_CLASS).text(
                data.successMessage
            );
            jQuery(ORDER_SUMMARY_DISCOUNT_PRICE_CLASS).text(data.savings);
        });
        return;
    } else if (isSubcribeAndSaveChecked && subscribe_and_save_discount > 0) {
        // they are subscribing, but this particular ad is not eligible for a discount
        if (!ignoreReset) {
            resetCouponFields();
            clearCouponFromCart();
        }
    } else {
        // they aren't subscribing, only ignore on calls where it has already been toggled, this also clears out non ss coupons otherwise.
        if (!ignoreReset) {
            resetCouponFields();
            if (gCouponCodeBeforeSubAndSave) {
                applyPromotion(gCouponCodeBeforeSubAndSave);
            } else {
                clearCouponFromCart();
            }
        }
    }

    jQuery(ORDER_SUMMARY_FINAL_TOTAL_PRICE_CLASS).text(
        format_currency(baseCost / 100)
    );
    enableCouponField();
    jQuery(ORDER_SUMMARY_DISCOUNT_DISCOUNT_JS).hide();
}

/**
 *
 */
function toggleSubscribed() {
    if (userHasSubscribeAndSaveSelected()) {
        // show the ad types that can be selected
        $(SS_OPTIONS_CONTAINER).show();
        // toggle highlight/gray background
        $(SS_OPTION_NOT_SUBSCRIBED).removeClass(
            SS_OPTION_SUBSCRIBED_SELECTED_CLASS
        );
        $(SS_OPTION_SUBSCRIBED).addClass(SS_OPTION_SUBSCRIBED_SELECTED_CLASS);
    } else {
        // toggle highlight/gray background
        $(SS_OPTION_NOT_SUBSCRIBED).addClass(
            SS_OPTION_SUBSCRIBED_SELECTED_CLASS
        );
        $(SS_OPTION_SUBSCRIBED).removeClass(
            SS_OPTION_SUBSCRIBED_SELECTED_CLASS
        );
        // hide the SS ad types that can be selected
        $(SS_OPTIONS_CONTAINER).hide();
    }
}

$(document).ready(() => {
    // If no sub and save options are present do not init javascript.
    if ($(SUBSCRIBE_SAVE_SUBS_CHECKBOX_SELECTOR).length > 0) {
        // initialize the highlight/selected gray background
        toggleSubscribed();

        handleSubscribeSaveFinalTotalPrice(true);

        // Subscribe and save learn more modal - cart summary
        let subscribeAndSaveLearnMoreModalCartSummary = new GenericBoostModal(
            ".subscribe-save-upsell__container", // container holding the modal opener - high enough?
            ".subscribe-save-upsell__learn-more--js", // modal opening link
            ".subscribe-save-learn-more-modal--js", // modal
            ".subscribe-save-learn-more-modal__close--js", // closeModalHandler
            "subscribe-save-learn-more-modal--active", // modalActiveClass
            "subscribe-save-learn-more-modal__bg" // modalBackgroundClass
        );

        // Subscribe and save learn more modal - boost settings page
        let subscribeAndSaveLearnMoreModalBoostSettings = new GenericBoostModal(
            ".tab-content", // container holding the modal opener - high enough?
            ".subscribe-save-upsell__learn-more--js", // modal opening link
            ".subscribe-save-learn-more-modal--js", // modal
            ".subscribe-save-learn-more-modal__close--js", // closeModalHandler
            "agent-promo-edit-campaign-modal--active", // modalActiveClass
            "agent-promo-edit-campaign-modal__bg" // modalBackgroundClass
        );

        // listen for toggling of subscribe n save
        $(SUBSCRIBE_SAVE_RADIO_SELECTOR)
            .off()
            .on("change", (e) => {
                toggleSubscribed();
                handleSubscribeSaveFinalTotalPrice();
            });

        // listen for changes to ad campaign types being subscribed to
        $(
            ".subscribe-save-upsell__container " +
                SUBSCRIBE_SAVE_SUBS_CHECKBOX_SELECTOR
        )
            .off()
            .on("change", (e) => {
                // may have to recalculate the price if they turn ad types on and off
                handleSubscribeSaveFinalTotalPrice();
            });
    }
});
